import { createSelector } from "reselect";
import { Record, List } from "immutable";

import { ContractToPauseDto } from "@typings/contracts";
import { LOADING_STATE } from "@typings/reduxThunkActions";

import { isDateInRange } from "@services/DateFormatter";

import { IStore } from "@app/redux/reducers";

import { Holiday as HolidayInterface } from "./holidays.typings";

const getHolidaysFunction = (store: IStore) => store.holidays.get("holidays");
export const getHolidays = createSelector(getHolidaysFunction, f => f);

const getHolidaysByLatestFunction = (store: IStore) =>
  store.holidays
    .get("holidays")
    .valueSeq()
    .sort((a, b) => {
      const firstDate = new Date(
        a.get("startDate").replace(" ", "T"),
      ).getTime();
      const secondDate = new Date(
        b.get("startDate").replace(" ", "T"),
      ).getTime();
      return firstDate - secondDate;
    });

export const getHolidaysByLatest = createSelector(
  getHolidaysByLatestFunction,
  f => f,
);

const isOngoingHolidayFunction = (store: IStore, holidayId: string) => {
  const selectedJob = store.holidays.getIn(["holidays", holidayId]);

  if (selectedJob) {
    const selectedJobStart = new Date(selectedJob.get("startDate"));
    const selectedJobEnd = new Date(selectedJob.get("endDate"));

    return isDateInRange(new Date(), selectedJobStart, selectedJobEnd);
  }

  return false;
};

export const isOngoingHoliday = createSelector(
  isOngoingHolidayFunction,
  f => f,
);

export const getProcessedHolidayFunction = (
  store: IStore,
): Record<HolidayInterface> | null => store.holidays.get("processedHoliday");

export const getProcessedHoliday = createSelector(
  getProcessedHolidayFunction,
  f => f,
);

export const getLoadingStateFn = (store: IStore): LOADING_STATE =>
  store.holidays.get("loadingState");

export const getLoadingState = createSelector(getLoadingStateFn, f => f);

export const getContractsToPauseFn = (
  store: IStore,
): List<ContractToPauseDto> => store.holidays.get("contractsToPause");

export const getContractsToPause = createSelector(
  getContractsToPauseFn,
  f => f,
);
